import { css } from "@emotion/css";

export const container = css`
position: absolute;
bottom: 0;
padding: 0 !important;
`;